import React, {createRef, RefObject} from 'react'

import Popover from "../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from '../../../gd-components/gd-popover/popover-position'
import PopoverHelpHint from "../../../gd-components/popover-menu/popover-help-hint/popover-help-hint"
import Project from "../../../model2/project/project"
import ProjectStatusManager from "../../../gd/manager/project-status-manager"
import VScroll from "../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import {ProjectSystemType} from "../../../model2/project/types"

// @ts-ignore
import SortInfo from '../../../gd-components/popover-menu/popover-help-hint/popover-help-hint-depricated'

type Props = {

    getTarget           : any

    project             : Project
    projectSystemType?  : any

    hint?               : boolean       // if true - show hint messages

    onStatusSelect      : onChangeCallback,

    hidePopover         : onChangeCallbackOptionalValue,
    togglePopover       : callback,

    // POPOVER ATTACHMENT
    popoverPosition     : PopoverPosition
}

export default class ProjectStatusSelectorPopover extends React.Component<Props, any> {

    private refHintMessage  : RefObject<PopoverHelpHint>

    constructor(props:Props) {
        super(props);

        this.refHintMessage   = createRef()
    }

    onStatusClick = (statusId:ID) => {
        this.props.onStatusSelect(statusId)
    }

    onEditStatusesClick = () => {
        this.props.togglePopover()

        gd.goTo('p/'+this.props.project.id+'/info/settings/workflow')
    }

    handleHoverOn = (info:string|null) => {
        if (!this.props.hint) return

        this.refHintMessage?.current?.setMessage(info)
    }

    handleHoverOff = () => {
        if (!this.props.hint) return
        this.refHintMessage?.current?.setMessage(null)
    }

    getStatuses = () => {
        let res = []

        const projectSystemType = this.props.projectSystemType ? this.props.projectSystemType : this.props.project.systemType;

        // switch (project.systemType) {
        switch (projectSystemType) {
            case ProjectSystemType.PROJECT:
            case ProjectSystemType.BACKLOG:
            case ProjectSystemType.SPRINT:
                res = ProjectStatusManager.getProjectStatuses(this.props.project.id);
                break;

            // case ProjectSystemType.TAG:
            // case ProjectSystemType.FOLDER:
            // case ProjectSystemType.PAGE:
            default:
                // res = ProjectStatusManager.getDefaultStatuses(project.systemType);
                res = ProjectStatusManager.getDefaultStatuses(projectSystemType);
                break;
        }

        return res;
    };

    render() {
        const projectStatuses = this.getStatuses();
        const project = this.props.project

        // const grouped = _.chain(projectStatuses)
        //     .orderBy(m=>m.systemStatus, 'asc')
        //     .groupBy(m=>{
        //         switch (m.systemStatus){
        //             case 1: return 'new';
        //             case 2:
        //             case 3: return 'in-progress';
        //         }
        //         return 'closed';
        //     })
        //     .toPairs()
        //     .value();

        let hintClasses: any = false;
        let manageStatuses: any = false;
        // no "Edit workflow" link for types whose workflow settings are read-only
        if (project &&
            gd.ac.check.company.isManager(project.companyId) &&
            project.systemType !== gd.const.project.type.WORKFOLDER &&
            project.systemType !== ProjectSystemType.SUPPORT_SYSTEM) {
            manageStatuses = (
                <div className="manage-statuses">
                    <div className="link" onClick={this.onEditStatusesClick}>Edit workflow</div>
                </div>
            );
            hintClasses = "with-edit-link"
        }

        return (
            <Popover popoverClass="gd-select-status-popover"
                     position={this.props.popoverPosition}
                     constraints={this.props.popoverPosition.constrains}
                     getTargetFunc={this.props.getTarget}
                     onClickOutside={()=>{this.props.hidePopover()}}>

                <VScroll scrollVisibility="auto">
                    {/*{grouped.map((group, key)=>*/}
                    {/*    <div key={key} className="status-group">*/}
                    {/*        {group[1].map((status, key)=>*/}
                    {/*            <div key={key} className="status"*/}
                    {/*                 onClick={this.onStatusClick.bind(this, status.id)}*/}
                    {/*                 onMouseEnter={this.handleHoverOn.bind(this, status.description)}*/}
                    {/*                 onMouseLeave={this.handleHoverOff} >*/}

                    {/*                <div className={'name gd-scf-'+status.color}>{status.name}</div>*/}
                    {/*            </div>*/}
                    {/*        )}*/}
                    {/*    </div>*/}
                    {/*)}*/}

                    <div className="status-group">
                        {_.map(projectStatuses, (status, key: number)=> {
                            return (
                                <div key={key} className="status"
                                     onClick={this.onStatusClick.bind(this, status.id)}
                                     onMouseEnter={this.handleHoverOn.bind(this, status.description)}
                                     onMouseLeave={this.handleHoverOff} >

                                    <div className={'name gd-scf-'+status.color}>{status.name}</div>
                                </div>
                            )
                        })}
                    </div>

                </VScroll>

                <SortInfo ref={this.refHintMessage} defaultMessage={"Select project status"} className={hintClasses} />

                {manageStatuses}
            </Popover>
        )
    }
}
